export default {
	type: 'ACCOUNT_DETAILS',
	name: 'Account details',
	allowedSections: ['footer', 'header', 'main'],
	disallowedChildren: ['*'],
	category: 'Account',
	props: [{
		name: 'email',
		inputType: 'checkbox',
		label: 'Show email',
		default: true
	},
	{
		name: 'name',
		inputType: 'checkbox',
		label: 'Show name',
		default: true
	},
	{
		name: 'mypages',
		inputType: 'checkbox',
		label: 'Show mypages link',
		default: true
	},
	{
		name: 'logout',
		inputType: 'checkbox',
		label: 'Show logout link',
		default: true
	}]
};
